/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AxiomEmployeeType {
  HQ = "HQ",
  Outsourcing = "Outsourcing",
  Projects = "Projects",
  Insourcing = "Insourcing",
}

export const AxiomEmployeeTypeDisplay: Record<AxiomEmployeeType, string> = {
  [AxiomEmployeeType.HQ]: "HQ",
  [AxiomEmployeeType.Outsourcing]: "Outsourcing",
  [AxiomEmployeeType.Projects]: "Projects",
  [AxiomEmployeeType.Insourcing]: "Insourcing",
};
